import React from 'react';
import PropTypes from 'prop-types';
import RiskFactorsListItem from './RiskFactorListItem';
import styled from 'styled-components';
import _ from 'lodash';

function RiskFactorsList(props) {
	const {
		riskFactorsList,
		isDisabled
	} = props;

	const riskFactorsOrderByName = _.orderBy(riskFactorsList, ['riskFactorName'], ['asc']);

	return (
		<>
			<StyledRiskFactorsList
				className={`StyledRiskFactorsList ${
					riskFactorsList.length > 0 ? 'teamevent-riskfactors' : 'noteamevent-riskfactors'
				}`}
			>
				{riskFactorsOrderByName.map((riskFactor) => (
					<RiskFactorsListItem key={riskFactor.id} riskFactorId={riskFactor.id} isDisabled={isDisabled} />
				))}
			</StyledRiskFactorsList>
		</>
	);
}

RiskFactorsList.propTypes = {
	riskFactorsList: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RiskFactorsList;

const StyledRiskFactorsList = styled.ul`
	font-size: var(--px-14);
	margin: 0;
	list-style: none !important;
	.riskfactor-name {
		padding-bottom: 0;
		display: flex;
		width: auto;
		max-width: 100%;
		.riskfactor-link {
			width: auto;
			max-width: 100%;
		}
	}
	.riskfactor-description {
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-20);
		margin-bottom: var(--px-24);
		color: var(--neutrals-700);
		padding: 0;
	}
	&.noteamevent-riskfactors {
		display: none;
	}
`;
